import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const profileRoute = createRoute({
  path: 'profile',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/profile/page'), 'ProfilePage'),
  errorComponent: RouteError,
})

export const profileLunarsRoute = createRoute({
  path: 'profile/lunars',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/profile/page'), 'ProfileLunarsPage'),
  errorComponent: RouteError,
})

export const profileSettingsRoute = createRoute({
  path: 'profile/settings',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/profile/page'), 'ProfileSettingsPage'),
  errorComponent: RouteError,
})

export const topupRoute = createRoute({
  path: 'profile/lunars/topup',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/topup/page'), 'TopupPage'),
  errorComponent: RouteError,
})
